import { Injectable } from '@angular/core';

@Injectable()
export class ApiTravelMemberAuthStorageService {
  private _travelMember: any;

  get travelMember(): any {
    return this._travelMember;
  }

  set travelMember(travelMember: any) {
    this._travelMember = travelMember;
  }

  get type(): any {
    return this._travelMember;
  }

  get travelMemberId(): number {
    return this.travelMember?.id;
  }
}
